import { Alert, Box, Container, Loader, Paper, Stack, Text, Title } from '@mantine/core';
import Header from '../components/Header';
import { useNavigate, useParams } from 'react-router-dom';
import { useServices } from '../hooks/useServices';
import { useEffect, useMemo } from 'react';
import { ChurchService } from '../models/ChurchService';
import { useChurch } from '../hooks/useChurch';

const isSameLocalDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

const CurrentServicePage = () => {
  const { churchId } = useParams<string>();
  const { services, loading: loadingServices } = useServices(churchId, 50);
  const { church } = useChurch(churchId);

  const currentService: ChurchService | undefined = useMemo(() => {
    const today = new Date();
    return services.find((s) => s.status === 'live') ||
      services.find((s) => s.status !== 'ended' && isSameLocalDay(s.date_of_service.toDate(), today));
  }, [services]);

  const navigate = useNavigate();

  useEffect(() => {
    if (currentService?.status === 'live' || (currentService && !currentService.status)) {
      navigate(`/church/${churchId}/service/${currentService.id}`);
    }
  }, [currentService, churchId]);

  if (!churchId) {
    return <Text>Missing churchId</Text>;
  }

  return (
    <main>
      <Header />
      <Box
        bg='linear-gradient(135deg, rgba(20, 33, 61, 0.08) 0%, rgba(13, 110, 253, 0.12) 100%)'
        py={{ base: 40, md: 72 }}
      >
        <Container size='xl' px={{ base: 'md', md: 'xl' }}>
          <Paper radius='lg' p='xl' shadow='md' withBorder>
            <Stack gap='md' align='center' ta='center'>
              {loadingServices ? (
                <Loader size='lg' />
              ) : currentService?.status === 'live' || (currentService && !currentService.status) ? null : (
                <>
                  <Title order={2}>{church?.name}</Title>
                  <Alert title={currentService ? 'Service has not started' : 'No live service today'} color='blue' variant='light'>
                    {currentService ? 'This page will open the live transcript when the AV team starts transcription.' : 'There isn’t a service scheduled today. When one starts, we’ll route listeners to the correct translation page automatically.'}
                  </Alert>
                </>
              )}
            </Stack>
          </Paper>
        </Container>
      </Box>
    </main>
  );
};

export default CurrentServicePage;
